<template>
  <div
    class="flex size-control items-center justify-center rounded-[8px] text-[--v3-theme-primarytextcolor] transition-colors duration-150"
    :class="{
      'bg-[--v3-theme-primarycolor] hover:bg-[--v3-theme-primarydarkercolor] group-hover:bg-[--v3-theme-primarydarkercolor]': variant === 'green' && !open,
      'bg-[--v3-erank-carrot] hover:bg-[--v3-erank-orangepizazz] group-hover:bg-[--v3-erank-orangepizazz]': variant === 'orange' && !open,
      'bg-[--v3-theme-primarydarkercolor]': variant === 'green' && open,
      'bg-[--v3-erank-regalblue]': variant === 'orange' && open,
    }"
  >
    <Icon name="star-solid" class="size-[18px]" />
  </div>
</template>

<script lang="ts" setup>
import Icon from '@/common/components/atoms/Icon';

withDefaults(
  defineProps<{
    variant?: 'orange' | 'green',
    open?: boolean,
  }>(), {
    variant: 'green',
    open: false,
  },
);
</script>

<style scoped>
/* Add your styles here */
</style>
